import React from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { IconLookup, NavBar, NavBarItem, BottomNavItems, NAV_BAR_ITEM_BASE_STYLE } from 'component-library-and-tools';

import WhiteLogo from 'shared/assets/splunk-trustar-white-logo.png';
import DarkLogo from 'shared/assets/splunk-trustar-dark-logo.png';
import { LogoutWrapper } from 'shared/components/LogoutWrapper';
import { goToStationWeb } from 'shared/utils';
import { DARK_THEME } from 'shared/constants';
import { getThemeMode } from 'services/user/getters';
import { colors } from 'lib/prisma-styles';
import { toggleTheme } from 'services/user/actions';

export const StyledWithNavBarContainer = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
`;

const StyledNavBar = styled(NavBar)`
  && {
    min-width: 19.25rem;
    max-width: 19.25rem;
    background-color: ${colors.background.page};
    border-right: 2px solid ${colors.interactive.defaultBackground};
    color: ${colors.content.default}
  }
`;

export const StyledNonNavContent = styled.div`
    flex: 1;
`;

const StyledLogoNavHeader = styled.div`
  ${NAV_BAR_ITEM_BASE_STYLE}
  height: auto;
  background-color: transparent;

  padding: 1rem 1rem 0.9rem 1rem;
  pointer-events: none;
  justify-content: center;

  > img {
      width: 50%;
  }
`;

const StyledNavBarItem = styled(NavBarItem)`
  &&& {
    background-color: transparent;
    color: inherit;
  }
`;

export const NavigationBar = () => {
  const theme = useSelector(getThemeMode);
  const logo = theme === DARK_THEME ? WhiteLogo : DarkLogo;

  // DEBUG
  const dispatch = useDispatch();

  return (
    <StyledNavBar>
        <StyledLogoNavHeader>
          <img src={logo} />
        </StyledLogoNavHeader>
      <StyledNavBarItem navIcon={IconLookup.ARROW_RETURN} onClick={goToStationWeb} title={'Back to Station'} />
      <BottomNavItems>
        {process.env.NODE_ENV === 'development' && (
          <StyledNavBarItem navIcon={IconLookup.ALARM_CHECK} title={'DB_ThemeSwitch'} onClick={() => dispatch(toggleTheme())}/>
        )}
        <LogoutWrapper>
          <StyledNavBarItem navIcon={IconLookup.EXIT} title={'Logout'} />
        </LogoutWrapper>
      </BottomNavItems>
    </StyledNavBar>
  );
};

export const AppWithNavBar = ({children} : {children: JSX.Element | React.ReactNode}) => (
  <StyledWithNavBarContainer>
      <NavigationBar />
      <StyledNonNavContent>
      {children}
      </StyledNonNavContent>
  </StyledWithNavBarContainer>
);


